import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(p, t, c, f, i, m) {
  return e(), o("svg", s, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 5.593a.75.75 0 0 1 .743.648l.007.102-.001 4.906h4.908a.75.75 0 0 1 .101 1.494l-.101.007-4.908-.001v4.908a.75.75 0 0 1-1.492.101l-.007-.101-.001-4.908H6.343a.75.75 0 0 1-.102-1.492l.102-.007 4.906-.001V6.343a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", a]]);
export {
  u as default
};
